import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./Css/View.css";
import API_BASE from "../config/api";

const StudentEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams(); 

  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [standards, setStandards] = useState([]);
  const [profileImage, setProfileImage] = useState(null);

  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const API_BASE_URL = `${API_BASE}`;

  /* ---------------- FETCH STUDENT ---------------- */
  useEffect(() => {
    if (!id) return;

    const fetchStudent = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/instituteadmin/students/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
            }
          }
        );

        setStudent(res.data);
        console.log(res.data, 'data')
      } catch (err) {
        console.error("Failed to fetch student", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [id]);

  /* ---------------- FETCH STANDARDS ---------------- */
  useEffect(() => {
    axios.get(`${API_BASE}/api/instituteadmin/students/all-standards`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      }

    )
      .then(res => setStandards(res.data));
  }, []);

  /* ---------------- IMAGE CHANGE ---------------- */
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) setProfileImage(file);
  };

  /* ---------------- INPUT CHANGE ---------------- */
  const handleChange = (e) => {
    setStudent({ ...student, [e.target.name]: e.target.value });
  };

  /* ---------------- SAVE ---------------- */
  const handleSave = async () => {
    try {
      const formData = new FormData();

      formData.append("StudentName", student.studentName);
      formData.append("ParentsName", student.parentsName);
      formData.append("ParentPhoneNumber", student.parentPhoneNumber);
      formData.append("Address", student.address);
      formData.append("BirthDate", student.birthDate);
      formData.append("StandardId", student.standardId);
      formData.append("IsActive", student.isActive);

      student.softwares.forEach(s =>
        formData.append("SoftwareIds", s.softwareId)
      );

      if (profileImage)
        formData.append("ProfilePicture", profileImage);

      await axios.put(
        `${API_BASE}/api/instituteadmin/students/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
          }

        }
      );

      navigate(`/dashboard/studentview/${id}`
        , {
          state: {
            instituteId: id
          }
        }
      );
    } catch {
      alert("Failed to update student");
    }
  };

  if (!student) return null;

  /* ================= JSX (UNCHANGED STYLES) ================= */

  return (
    <div className="student-page">

      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          संस्था व्यवस्थापन &gt;&gt; तपशील &gt;&gt; विद्यार्थी माहिती &gt;&gt;
          <span> विद्यार्थी संपादन</span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
          <button className="btn primaryy" onClick={handleSave}>
            सेव्ह करा
          </button>
        </div>
      </div>

      <p>संस्थेचे नाव: <strong>{student.instituteName}</strong></p>

      <h2>विद्यार्थी संपादन करा</h2>

      {/* PROFILE */}
      <div className="profile-card">
        <div className="profile-img-wrapper">
          <img
            src={profileImage
              ? URL.createObjectURL(profileImage)
              : student.profilePictureUrl }
            alt="student"
            className="profile-img"
          />

          <label className="edit-icon">
            <input type="file" accept="image/*" onChange={handleImageChange} hidden />
          </label>
        </div>
      </div>

      {/* FORM */}
      <div className="info-gridd">

        <div className="info-boxx">
          <label>विद्यार्थ्याचे नाव</label>
          <input
            name="studentName"
            value={student.studentName || ""}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>इयत्ता</label>
          <select
            name="standardId"
            value={student.standardId | ""}
            onChange={handleChange}
          >
            {standards.map(s => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>
        </div>

        <div className="info-boxx">
          <label>जन्मतारीख</label>
          <input
            type="date"
            name="birthDate"
            value={student.birthDate?.split("T")[0]}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>पत्ता</label>
          <input
            name="address"
            value={student.address}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>ईमेल</label>
          <input value={student.email} disabled />
        </div>

        <div className="info-boxx">
          <label>पालकांचे नाव</label>
          <input
            name="parentsName"
            value={student.parentsName}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>पालकांचा दूरध्वनी क्रमांक</label>
          <input
            name="parentPhoneNumber"
            value={student.parentPhoneNumber}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default StudentEdit;